/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Wise_PayoutsInputs */

const en_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual Wise Payouts`)
};

const es_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagos manuales con Wise`)
};

const fr_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements manuels Wise`)
};

const de_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Wise-Auszahlungen`)
};

const ja_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動のWise支払い`)
};

const zh_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动 Wise 提现`)
};

const ar_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدفوعات Wise اليدوية`)
};

const id_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran Wise Manual`)
};

const it_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamenti Manuali Wise`)
};

const ru_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручные выплаты через Wise`)
};

const pt_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamentos Manuais via Wise`)
};

const ko_manual_wise_payouts = /** @type {(inputs: Manual_Wise_PayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수동 Wise 정산`)
};

/**
* | output |
* | --- |
* | "Manual Wise Payouts" |
*
* @param {Manual_Wise_PayoutsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const manual_wise_payouts = /** @type {((inputs?: Manual_Wise_PayoutsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Wise_PayoutsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manual_wise_payouts(inputs)
	if (locale === "es") return es_manual_wise_payouts(inputs)
	if (locale === "fr") return fr_manual_wise_payouts(inputs)
	if (locale === "de") return de_manual_wise_payouts(inputs)
	if (locale === "ja") return ja_manual_wise_payouts(inputs)
	if (locale === "zh") return zh_manual_wise_payouts(inputs)
	if (locale === "ar") return ar_manual_wise_payouts(inputs)
	if (locale === "id") return id_manual_wise_payouts(inputs)
	if (locale === "it") return it_manual_wise_payouts(inputs)
	if (locale === "ru") return ru_manual_wise_payouts(inputs)
	if (locale === "pt") return pt_manual_wise_payouts(inputs)
	return ko_manual_wise_payouts(inputs)
});